import React from "react";
import { cn } from "../../../common/u1/cn";

/* One company in a dashboard list — the followed businesses and the purchases share it, so the two lists cannot drift apart. */
export const CompanyRow = ({
  name,
  location,
  to,
  target,
  trailing,
  divided = false,
  className = "",
}) => {
  const body = (
    <>
      <Avatar name={name} />
      <span className="min-w-0 flex-1">
        <span className="block truncate text-[15.5px] font-medium text-[var(--ink)] font-sans">
          {name}
        </span>
        {location && (
          <span className="mt-0.5 block truncate text-[13px] text-[var(--muted)] font-sans">
            {location}
          </span>
        )}
      </span>
      {trailing}
    </>
  );

  /* No rule between rows: the design separates them with space and a hover
     fill, not a line. `divided` opts a list back into the hairline — the
     purchases table uses it. */
  const shared = cn(
    "flex items-center gap-[15px] rounded-[14px] px-3.5 py-[13px] transition-colors",
    to && "cursor-pointer hover:bg-[var(--field-inset)]",
    divided && "rounded-none shadow-[inset_0_-1px_0_var(--line-2)] last:shadow-none",
    className
  );

  if (!to) return <div className={shared}>{body}</div>;

  return (
    <a href={to} target={target} className={shared}>
      {body}
    </a>
  );
};

/* The design's circular mark: the company's initial on a blue gradient. The
   letter is decorative — the name sits beside it. */
export const Avatar = ({ name = "" }) => (
  <span
    aria-hidden="true"
    className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[radial-gradient(circle_at_35%_30%,#5b8bff,#1c46d6)] text-[16px] font-bold text-white shadow-[inset_0_0_0_2px_rgba(255,255,255,.35)]"
  >
    {String(name).trim().charAt(0).toUpperCase() || "?"}
  </span>
);

export default CompanyRow;
